module.exports = __webpack_public_path__ + "img/rank_private.885a937a.svg";